import { z } from 'zod'

// Кросс-контекстный VO: кто совершил действие. Делят document/comment/task/
// invoice/meeting/activity — поэтому живёт в shared, а не в entity.
// Форма зеркалит бэкенд (snake_case): {kind, id}, read-view добавляет name.

export const ActorKindSchema = z.enum(['employee', 'customer'])
export type ActorKind = z.infer<typeof ActorKindSchema>

export const ActorRefSchema = z.object({ kind: ActorKindSchema, id: z.string() })
export interface ActorRef {
  kind: ActorKind
  id: string
}

export const ActorNameSchema = z.object({
  kind: ActorKindSchema,
  id: z.string(),
  name: z.string().optional(),
})
export interface ActorName extends ActorRef {
  name?: string
}

// Стабильный ключ для React-списков и карт резолва.
export function actorKey(actor: ActorRef): string {
  return `${actor.kind}:${actor.id}`
}

// Имя актора: из read-view (бэкенд резолвит) либо по картам сущностей, если
// на руках только {kind, id} (write-view). Fallback — пусто.
export function resolveActorName(
  actor: ActorName,
  maps?: { employees?: Map<string, string>; customers?: Map<string, string> },
): string {
  if (actor.name) return actor.name
  const map = actor.kind === 'employee' ? maps?.employees : maps?.customers
  return map?.get(actor.id) ?? ''
}
